package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.SearchHistory
import com.example.readingnotes.domain.repository.PostRepository
import com.example.readingnotes.util.Result

class GetSearchHistoryUseCase(
    private val postRepository: PostRepository,
) {
    suspend operator fun invoke(): Result<List<SearchHistory>> = postRepository.getSearchHistory()
}

class ClearSearchHistoryUseCase(
    private val postRepository: PostRepository,
) {
    suspend operator fun invoke(): Result<Unit> = postRepository.clearSearchHistory()
}
